import { TabsProps } from "@/common/components/Tabs";
import { MaintenaceWorkflowData } from "../types/maintenanceWorkflows.type";
import { createElement } from "react";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import MaintenanceWorkflowForwardingsTab from "../pages/Show/components/tabs/ForwardingsTab/MaintenanceWorkflowForwardingsTab";
import MaintenanceDescription from "../pages/Show/components/tabs/MaintenanceDescription";

export const getWorkflowTabsList = (
  workflow: MaintenaceWorkflowData | undefined,
  forwardingsDirectiveEntryKlasses: MaintenanceForwardingsDirectiveEntryKlass[] | undefined,
) => {
  let forwardingsDirectiveEntryKlassesTabs: TabsProps['tabsList'] = [];

  if (forwardingsDirectiveEntryKlasses) {
    forwardingsDirectiveEntryKlassesTabs = forwardingsDirectiveEntryKlasses
      .map((directiveEntryKlass) => {
        const tab = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass];

        if (!tab) {
          return false;
        }

        return {
          value: directiveEntryKlass,
          label: tab.label,
          body: createElement(MaintenanceWorkflowForwardingsTab, {
            workflow,
            directiveEntryKlass,
          }),
        };
      })
      .filter((tab) => tab) as TabsProps['tabsList'];
  }

  return [
    {
      label: 'Descrição da manutenção',
      value: '',
      body: createElement(MaintenanceDescription, { workflow }),
    },
    ...forwardingsDirectiveEntryKlassesTabs,
  ] as TabsProps['tabsList'];
}
